export default __webpack_public_path__ + "static/media/incorrect2.a5b1de5d.mp3";